import React from 'react';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import PageBanner from '../components/PageBanner';
import ServiceSidebar from '../components/ServiceSidebar';
import ServiceContactForm from '../components/ServiceContactForm';
import { SRLWrapper } from 'simple-react-lightbox';
import img1 from '../assets/img/gallery/5.jpg';
import img2 from '../assets/img/gallery/6.jpg';
import FaqAccordion from '../components/FaqAccordion';

function RapidPrototypingService() {
    const bannerBg = '/service-hero-bg.jpg';

    return (
        <>
            <Header1 />
            <PageBanner
                bannerBg={bannerBg}
                heading="Rapid Prototyping & Product Design"
                currentPage="Rapid Prototyping & Product Design"
            />
            <section className="service-details-wrapper section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-4 mt-5 mt-md-0 col-12 order-2 order-md-1">
                            <ServiceSidebar />
                        </div>
                        <div className="col-lg-9 col-md-8 col-12 order-1 order-md-2">
                            <div className="service-details-content-wrapper pl-0 pl-md-4">
                                <h2>Fast Turnover of High Quality Prototypes</h2>
                                <p>
                                    We offer prototypes in various materials - CNC machined or 3D printed with various technologies
                                    available to suit your needs. Our rapid prototyping services combine advanced 5-axis CNC machining
                                    and cutting-edge 3D printing technologies to deliver high-quality prototypes quickly and cost-effectively.
                                </p>

                                <h2>Advanced Manufacturing Technologies</h2>
                                <p>
                                    Our state-of-the-art facilities feature 5-axis CNC machining centres capable of producing complex
                                    geometries with exceptional precision. We also offer multiple 3D printing technologies including
                                    FDM, SLA, and SLS, allowing us to select the perfect method for your specific requirements. Whether
                                    you need metal prototypes, functional plastics, or concept models, we have the technology and
                                    expertise to deliver.
                                </p>

                                {/* <SRLWrapper>
                                    <div className="row">
                                        <div className="col-md-6 col-12">
                                            <a href={img1} className="popup-gallery">
                                                <img src={img1} alt="5-Axis CNC Machining" />
                                            </a>
                                        </div>
                                        <div className="col-md-6 col-12">
                                            <a href={img2} className="popup-gallery">
                                                <img src={img2} alt="3D Printing Technologies" />
                                            </a>
                                        </div>
                                    </div>
                                </SRLWrapper> */}

                                <h2>Material Options & Flexibility</h2>
                                <p>
                                    Choose from an extensive range of materials to match your prototype's functional requirements.
                                    Our CNC machining services work with aluminium, steel, brass, plastics, and engineering polymers.
                                    For 3D printing, we offer options including ABS, PLA, nylon, TPU, resin, and specialised engineering
                                    materials. This flexibility ensures your prototype accurately represents the final product's
                                    performance characteristics.
                                </p>

                                <blockquote>
                                    Fast turnover without compromising quality - transform your concepts into tangible prototypes
                                    in record time with ProtoPath's advanced prototyping capabilities.
                                </blockquote>

                                <div className="faq-content pl-0 pl-md-4 mt-5">
                                    <h2>Service Includes</h2>
                                    <FaqAccordion
                                        question="5-Axis CNC Machining"
                                        answer="High-precision machining for complex geometries in metals and plastics, delivering prototypes with exceptional surface finish and dimensional accuracy."
                                    />
                                    <FaqAccordion
                                        question="Multiple 3D Printing Technologies"
                                        answer="FDM, SLA, and SLS 3D printing options to suit different applications, from concept models to functional prototypes requiring specific material properties."
                                    />
                                    <FaqAccordion
                                        question="Rapid Turnaround"
                                        answer="Fast delivery times with most prototypes completed within days, enabling quick design iterations and accelerated product development cycles."
                                    />
                                </div>

                                <ServiceContactForm serviceName="Rapid Prototyping & Product Design" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer1 />
        </>
    );
}

export default RapidPrototypingService;
